export default __webpack_public_path__ + "static/media/ar-not-created.6470a2ef.svg";